import { Box, Divider, Grid, GridItem, Text, useDisclosure } from "@chakra-ui/react";
import { Breadcrumb, Container, Heading, Icon, Pressable } from "components";
import ProductsSales from "./product-sales";
import DistributorPurchasesSold from "./distributor-purchase-sold";

export default function Orders(){

    const productSales = useDisclosure()
    const distributorPurchasesSold = useDisclosure()

    return(
    <Container>

        {/* Modals */}
        <ProductsSales {...productSales} />
        <DistributorPurchasesSold {...distributorPurchasesSold} />

        <Breadcrumb prev={{ path: '/tools', label: 'Ferramentas' }} current="Relatórios de pedidos" />

        <Heading title="Relatórios de pedidos" />

        <Divider my={4} />

        <Grid templateColumns="1fr 1fr 1fr 1fr" gap={6}>

            <GridItem>
                <Pressable onClick={productSales.onOpen}>
                    <Box p={4} borderRadius={8} bgGradient="linear-gradient(62deg, #00d2ff 0%, #3a47d5 100%)" boxShadow="4px 4px 14px rgba(0,0,0,0.3)">
                        <Icon name="identity" fontSize="2rem" color="#FFF" />
                        <Text color="#FFF" fontWeight="bold" children="Produtos vendidos (Matriz)" />
                        <Text color="#FFF" fontSize="xs" children="Busca de produtos vendidos por período." />
                    </Box>
                </Pressable>
            </GridItem>

            <GridItem>
                <Pressable onClick={distributorPurchasesSold.onOpen}>
                    <Box p={4} borderRadius={8} bgGradient="linear-gradient(62deg, #00d2ff 0%, #3a47d5 100%)" boxShadow="4px 4px 14px rgba(0,0,0,0.3)">
                        <Icon name="identity" fontSize="2rem" color="#FFF" />
                        <Text color="#FFF" fontWeight="bold" children="Compra x Venda (Núcleo)" />
                        <Text color="#FFF" fontSize="xs" children="Produtos comprados x vendidos de um núcleo" />
                    </Box>
                </Pressable>
            </GridItem>

        </Grid>

    </Container>
    )
}
